module.exports = __webpack_public_path__ + "static/media/ExoBNNVARA-ExtraBold.731cd206.woff";